import { render, staticRenderFns } from "./Page-Map-Countries.vue?vue&type=template&id=5a80196c&"
import script from "./Page-Map-Countries.vue?vue&type=script&lang=js&"
export * from "./Page-Map-Countries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports